/* ============================================================
   Wido Ops — notifications: tailored feed + dropdown panel.
   Exports window.notificationsFor(person), window.NotificationsPanel.
   ============================================================ */
(function () {
  const D = window.WidoData;

  // Build a tailored notification feed for the signed-in person.
  function notificationsFor(person) {
    if (!person) return [];
    const role = (D.ROLES.find((r) => r.id === person.roleId) || {});
    const perms = role.perms || [];
    const has = (p) => perms.includes(p);
    const first = person.name.split(" ").slice(-1)[0];
    const list = [];
    let n = 0;
    const push = (o) => list.push(Object.assign({ id: "n" + (++n), unread: true }, o));

    // ---- personal (everyone) ----
    push({ type: "request_approved", icon: "check_circle", color: "var(--md-primary)",
      title: "Leave request approved", body: "Your annual-leave request for Jun 12 was approved by Nguyen Van Tuan.", time: "2h ago" });
    push({ type: "request_submitted", icon: "send", color: "var(--md-secondary)",
      title: "Request submitted", body: "Your late-arrival request (45m, Jun 09) was sent to your leader for approval.", time: "5h ago" });
    push({ type: "fund_low", icon: "battery_alert", color: "var(--md-tertiary)",
      title: "Flexible fund running low", body: "You've used 75 of your 300 monthly minutes. 75 left for June.", time: "Yesterday" });
    push({ type: "request_rejected", icon: "cancel", color: "var(--md-error)", unread: false,
      title: "Request not approved", body: "Your early-leave request for Jun 03 was declined. Reason: deadline week.", time: "2 days ago" });
    if (D.helpers.dailyActive(person.id)) {
      push({ type: "daily_grant", icon: "child_care", color: "var(--md-tertiary)",
        title: "Daily free minutes active", body: "Your nursing grant (60 min/day) is applied before your monthly fund.", time: "3 days ago" });
    }
    push({ type: "account_activated", icon: "verified_user", color: "var(--md-primary)", unread: false,
      title: "Welcome to Wido Ops", body: "Your account was activated by HR. You're all set.", time: "Jun 01" });

    // ---- leaders / HR / BOD ----
    if (has("request.approve.team") || has("request.approve.all")) {
      const scope = has("request.approve.all") ? "company-wide" : "your team";
      // Count only requests this person can ACT on — HR has company-wide VIEW
      // but decides offsets alone, so don't surface a queue they can't clear.
      const cnt = D.requests.filter((r) => r.status === "pending" && D.helpers.canActOnRequest(person, r)).length;
      if (cnt > 0) push({ type: "pending_approvals", icon: "fact_check", color: "var(--md-tertiary)",
        title: cnt + " " + window.t(cnt > 1 ? "requests awaiting approval" : "request awaiting approval"), body: "Pending requests awaiting your decision across " + scope + ".", time: "1h ago" });
    }
    if (has("account.activate")) {
      const pend = D.pendingAccounts.length;
      if (pend) push({ type: "pending_signups", icon: "how_to_reg", color: "var(--md-tertiary)",
        title: pend + " new Google sign-in" + (pend > 1 ? "s" : ""), body: "New @widogame.com accounts need activation before they can use Wido Ops.", time: "4h ago" });
      push({ type: "account_deactivated", icon: "sync_lock", color: "var(--md-on-surface-variant)", unread: false,
        title: "Account auto-deactivated", body: "Pham Van Loc was removed from Google Workspace and deactivated here.", time: "Yesterday" });
    }
    if (has("payroll.offset") || has("request.approve.all")) {
      push({ type: "payroll_reminder", icon: "payments", color: "var(--md-secondary)",
        title: "Payroll closes Jun 30", body: "Review unpaid minutes and confirm any annual-leave offsets before close.", time: "Today" });
    }
    if (has("attendance.override")) {
      push({ type: "override", icon: "edit_calendar", color: "var(--md-secondary)", unread: false,
        title: "Manual entry recorded", body: "You added a clock-out for Do Gia Bao on Jun 05 (door reader offline).", time: "2 days ago" });
    }
    return list;
  }

  function NotificationsPanel({ items, onClose, onMarkAll, onOpen }) {
    const unread = items.filter((i) => i.unread).length;
    return React.createElement(React.Fragment, null,
      React.createElement("div", { style: { position: "fixed", inset: 0, zIndex: 39 }, onClick: onClose }),
      React.createElement("div", { className: "menu", style: { width: 380, maxWidth: "calc(100vw - 24px)", padding: 0, overflow: "hidden" } },
        React.createElement("div", { className: "between", style: { padding: "14px 16px", borderBottom: "1px solid var(--md-outline-variant)" } },
          React.createElement("div", { className: "row", style: { gap: 8 } },
            React.createElement("strong", { style: { fontSize: 15 } }, "Notifications"),
            unread > 0 && React.createElement("span", { className: "navitem__badge", style: { position: "static" } }, unread)),
          unread > 0 && React.createElement("button", { className: "btn btn--text btn--sm", onClick: onMarkAll }, "Mark all read")),
        React.createElement("div", { style: { maxHeight: 420, overflowY: "auto" } },
          items.length === 0
            ? React.createElement("div", { className: "empty", style: { padding: "40px 20px" } }, React.createElement("span", { className: "material-symbols-rounded" }, "notifications_off"), React.createElement("p", null, "You're all caught up."))
            : items.map((i) => React.createElement("button", { key: i.id, onClick: () => onOpen(i),
                style: { display: "flex", gap: 12, width: "100%", textAlign: "left", border: "none", cursor: "pointer", padding: "12px 16px", background: i.unread ? "color-mix(in srgb, var(--md-primary) 5%, transparent)" : "transparent", borderBottom: "1px solid var(--md-outline-variant)" } },
                React.createElement("div", { style: { width: 38, height: 38, borderRadius: "50%", flexShrink: 0, display: "grid", placeItems: "center", background: i.color.replace("var(", "color-mix(in srgb, var(").replace(")", ") 16%, transparent)") } },
                  React.createElement("span", { className: "material-symbols-rounded", style: { color: i.color, fontSize: 20 } }, i.icon)),
                React.createElement("div", { className: "stack-v", style: { gap: 2, minWidth: 0, flex: 1 } },
                  React.createElement("div", { className: "between", style: { gap: 8 } },
                    React.createElement("span", { style: { font: "500 14px/1.3 var(--font-sans)" } }, i.title),
                    i.unread && React.createElement("span", { style: { width: 8, height: 8, borderRadius: "50%", background: "var(--md-primary)", flexShrink: 0, marginTop: 5 } })),
                  React.createElement("span", { className: "muted", style: { fontSize: 12.5, lineHeight: 1.45 } }, i.body),
                  React.createElement("span", { className: "muted", style: { fontSize: 11 } }, i.time)),
              ))),
      ),
    );
  }

  Object.assign(window, { notificationsFor, NotificationsPanel });
})();
